import React from 'react';
import PropTypes from 'prop-types';
import { FDLozenge, FDStack } from '@facet-wealth/design';
import Typography from 'Components/UI/Typography';
import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { dataAttrs } from 'Helpers/Testing';

function AssetsAndLiabilitiesHeader({
  resource,
}) {
  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <FDLozenge label={resource.attr('stepText')} color={'info'} size={'lg'} {...dataAttrs('step-text-lozenge')} />
      <Typography
        style={{
          fontSize: '38px',
        }}
        variant={'h1'}
        weight={'medium'}
        color={'primary'}
        align={'center'}
      >
        {resource.attr('title')}
      </Typography>
      <FDStack direction={'column'} spacing={2}>
        {resource.attr('subtitle').map((text) => (
          <Text
            variant="h5"
            color="primaryGray"
            weight={'medium'}
            align={'center'}
            value={text}
            lineHeight={'small'}
          />
        ))}
      </FDStack>
    </FDStack>

  );
}

AssetsAndLiabilitiesHeader.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

AssetsAndLiabilitiesHeader.defaultProps = {
};

export default AssetsAndLiabilitiesHeader;
